function createSVGObjectPoint() {
  let svgNS = 'http://www.w3.org/2000/svg';
  let newSVG = document.createElementNS(svgNS, 'svg');
  newSVG.setAttribute('width', '9');
  newSVG.setAttribute('height', '10');
  newSVG.setAttribute('viewBox', '0 0 9 10');
  newSVG.setAttribute('fill', 'none');
  newSVG.setAttribute('class', 'random-pill random-point');

  let circle = document.createElementNS(svgNS, 'circle');
  circle.setAttribute('cx', '4.51379');
  circle.setAttribute('cy', '4.61377');
  circle.setAttribute('r', '4.40832');
  circle.setAttribute('fill', 'url(#paint0_radial_435_82)');

  let defs = document.createElementNS(svgNS, 'defs');
  let radialGradient = document.createElementNS(svgNS, 'radialGradient');
  radialGradient.setAttribute('id', 'paint0_radial_435_82');
  radialGradient.setAttribute('cx', '0');
  radialGradient.setAttribute('cy', '0');
  radialGradient.setAttribute('r', '1');
  radialGradient.setAttribute('gradientUnits', 'userSpaceOnUse');
  radialGradient.setAttribute('gradientTransform', 'translate(4.51379 4.61377) rotate(90) scale(4.40832)');

  let stop1 = document.createElementNS(svgNS, 'stop');
  stop1.setAttribute('stop-color', '#C4C4C4');

  let stop2 = document.createElementNS(svgNS, 'stop');
  stop2.setAttribute('offset', '1');
  stop2.setAttribute('stop-color', '#C4C4C4');
  stop2.setAttribute('stop-opacity', '0');

  radialGradient.appendChild(stop1);
  radialGradient.appendChild(stop2);
  defs.appendChild(radialGradient);
  newSVG.appendChild(circle);
  newSVG.appendChild(defs);

  document.body.appendChild(newSVG);

  let docWidth = document.documentElement.scrollWidth;
  let docHeight = document.documentElement.scrollHeight;

  newSVG.style.top = Math.floor(Math.random() * docHeight) + 'px';
  newSVG.style.right = Math.max(Math.floor(Math.random() * docWidth), 0) + 'px';

  let animationDuration = Math.random() * 10 + 20; // between 20 and 30 seconds
  let animationDelay = Math.random() * 5;

  newSVG.style.animationDuration = animationDuration + 's';
  newSVG.style.animationDelay = animationDelay + 's';

  newSVG.classList.add('random-move');
}

for (let i = 0; i < 30; i++) {
  createSVGObjectPoint();
}
